import join from 'join-array';
import { HUMAN_JOIN_MAX } from '../store/constants';

export default {
  methods: {
    joinStrings(array) {
      return join(array, ', ', ` ${this.$t('conjunctions.and')} `, HUMAN_JOIN_MAX);
    },
  },
};
